export const deviceStatusPageSize = 20;
export const deviceStatusPageSizeOptions = [20, 40, 100];
export const startDateLimit = 89;
export const commonHeaders = {
    // serialNumber: "S.No",
    ts: {header:"Timestamp",desc:""},
};